export enum MyHistoryTypes {
  GET_MY_HISTORY_REQUEST = '@myHistory/GET_MY_HISTORY_REQUEST',
  GET_MY_HISTORY_SUCCESS = '@myHistory/GET_MY_HISTORY_SUCCESS',
  GET_MY_HISTORY_FAILURE = '@myHistory/GET_MY_HISTORY_FAILURE',
  GET_FOLLOWUPS_REQUEST = '@my_history/GET_FOLLOWUPS_REQUEST',
  GET_FOLLOWUPS_SUCCESS = '@my_history/GET_FOLLOWUPS_SUCCESS',
  GET_FOLLOWUPS_FAILURE = '@my_history/GET_FOLLOWUPS_FAILURE',
  GET_LIST_ITENS_REQUEST = '@my_history/GET_LIST_ITENS_REQUEST',
  GET_LIST_ITENS_SUCCESS = '@my_history/GET_LIST_ITENS_SUCCESS',
  GET_LIST_ITENS_FAILURE = '@my_history/GET_LIST_ITENS_FAILURE',
}

export interface ItemVencido {
  id: number;
  descricao: string;
  bidding_id: number;
  orgao: string | null;
  estado: string | null;
  cidade: string | null;
  portal_id: number;
  quantidade: number | null;
  valor_final: number;
  edital: string;
  objeto: string;
  processo: string;
  data_validade: string;
}

export interface ModalidadeResumo {
  modalidade: number | string | null;
  quantidade: number;
}

export interface RegiaoResumo {
  regiao: string | null;
  quantidade: number;
}

export interface OrgaoResumo {
  orgao: string | null;
  estado: string | null;
  licitacoes: number;
  investimento: number;
}

export interface PortalResumo {
  portal: string;
  licitacoes: number;
  investimento: number;
}

export interface ItensVencidos {
  numero_item: number;
  participante_nome: string;
  descricao: string;
  quantidade_ofertada: number;
  valor_final: number;
}

export interface HistoryTypes {
  total_itens_vencidos: number;
  itens_vencidos: ItemVencido[];
  licitacoes_por_modalidade: ModalidadeResumo[];
  licitacoes_por_regiao: RegiaoResumo[];
  licitacoes_por_orgao: OrgaoResumo[];
  licitacoes_por_portal: PortalResumo[];
  count_bidding_monitored: number;
  followups: Array<any>;
  total_investimento: number;
  itens: Array<ItensVencidos>;
  total_itens: number;
}

export interface RequestState {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface RequestFollowupsState {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface RequestListItensState {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface MyHistoryState {
  my_history: HistoryTypes;
  request: RequestState;
  request_followups: RequestFollowupsState;
  request_list_itens: RequestListItensState;
}
